import { PropsWithChildren } from "react";
import styles from "./Tile.module.css";

export const TileContainer = (props: PropsWithChildren<{}>) => {
    return (
        <div className={styles.TileContainer}>
            {props.children}
        </div>
    );
};
